import { Grid } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import { makeStyles } from '@material-ui/core/styles';
import Pagination from '@material-ui/lab/Pagination';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import CurrencyFormat from 'react-currency-format';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import LeftSide from '../components/LeftSide';
import Navbar from '../components/Navbar';
import TickerNews from '../components/TickerNews';
import TradeDetailModal from '../components/TradeDetailModal';
import ViewDetailModal from '../components/ViewDetailModal';
import axiosInstance from '../config';
import { fetchSabaTradeDetail } from '../api/saba';
import { logout } from '../components/Utils';
import '../styles/HistoryDetail.css';

const useStyles = makeStyles((theme) => ({
  none: {
    display: 'none',
  },
  reject: {
    textDecoration: 'line-through',
  },
  strong: {
    color: '#323030',
  },
  MainArea: {
    width: '100%',
    display: 'grid',
    placeItems: 'center',
    maxWidth: '1180px',
    margin: '86px auto auto !important',
    float: 'none !important',
  },
  MainArea2: {
    width: '80%',
    display: 'grid',
    placeItems: 'center',
    maxWidth: '1180px',
    margin: '10px auto auto !important',
    float: 'none !important',
  },
  teams: {
    fontSize: '12px',
    color: '#323030',
    margin: '0.15rem 0 !important',
  },
  compName: {
    fontWeight: 'bold',
    fontSize: '12px',
    color: '#323030',
  },
  spacing: {
    padding: '0.35rem 0.5rem',
  },
  table: {
    width: '100%',
  },
  index: {
    fontSize: '12px',
    color: '#323030',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  score: {
    fontSize: '12px',
    color: '#323030',
    textAlign: 'center',
    fontWeight: 'bold',
  },
  result: {
    fontSize: '12px',
    color: '#323030',
    textAlign: 'center',
  },
  money: {
    fontSize: '12px',
    color: '#1452CC',
    textAlign: 'right',
    fontWeight: 'bold',
  },
  flex: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '10px',
    maxHeight: '18px',
  },
  flex2: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  img: {
    height: '18px',
    width: '18px',
    margin: '0 0.5rem',
  },
  header: {
    color: '#18334C',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  negative: {
    color: '#E91F1F',
  },
  blue: {
    color: '#1452CC',
    fontWeight: 'bold',
    fontSize: '12px',
  },
  view: {
    backgroundColor: '#fff',
    color: '#86898C',
    lineHeight: '12px',
    fontWeight: 'bold',
    fontSize: '12px',
    border: '1px solid #86898C',
    borderRadius: '4px',
    cursor: 'pointer',
    padding: '0.3rem',
  },
  handiCap: {
    color: '#1452CC ',
    fontSize: '12px',
    fontWeight: 'bold',
    margin: '0.15rem 0rem !important',
  },
  print: {
    color: '#1452CC ',
    fontSize: '12px',
    fontWeight: 'bold',
    margin: '0.15rem 0.35rem !important',
  },
  running: {
    color: '#E91F1F',
    fontSize: '11px',
    fontWeight: 'bold',
    margin: '0.15rem 0 !important',
  },
  Modal: {
    margin: '0 auto',
    width: '800px',
    backgroundColor: '#fff',
    borderRadius: '4px',
  },
  modalStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  blank: {
    backgroundColor: '#86898C',
  },
  LeftPanel: {
    width: '20%',
  },
  RightPanel: {
    width: '80%',
    marginTop: '10px',
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: '0.3rem 0',
  },
  font14: {
    fontSize: '14px',
  },
}));
const HistoryDetail = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const history = useHistory();
  const [detail, setDetail] = useState(null);
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  // a WeGa row stores no detail of its own, so "View Detail" asks the backend for the vendor's page for that
  // bet and frames it. The url carries a one-shot ticket, so it is dropped again as soon as the modal closes.
  const [tradeDetail, setTradeDetail] = useState({
    open: false,
    loading: false,
    url: null,
  });
  //   single quote
  const [quote, setQuote] = useState(null);
  const printRef = useRef();
  const [totalPage, setTotalPage] = useState(null);
  const [sportsCount, setSportsCount] = useState(0);

  // Games (Wega/SABA) and WeGa sport are two independent reads of the same day - own rows, own pagination,
  // own footer - and they are two *populations*, not one: a `WEGA` category is accounted by the games stake
  // settings, a `SPORT` category is a WeGa sports bet, accounted exactly like an own-sports bet. So the page
  // shows one segment per population (Sports / WeGa sport / Games) off `portal/wega/detail?engine=`, and the
  // two WeGa segments share one table shape: a WeGa sports row carries no teams, odds, handicap or score
  // either, so the same columns serve both.
  const [tab, setTab] = useState(0);
  const [wegaSportDetail, setWegaSportDetail] = useState(null);
  const [wegaSportTotalPage, setWegaSportTotalPage] = useState(null);
  const [wegaSportCount, setWegaSportCount] = useState(0);
  const [gameDetail, setGameDetail] = useState(null);
  const [gameTotalPage, setGameTotalPage] = useState(null);
  const [gameCount, setGameCount] = useState(0);

  const [stakeTotal, setStakeTotal] = useState(0);
  const [winningTotal, setWinningTotal] = useState(0);
  const [commissionTotal, setCommissionTotal] = useState(0);
  const [netWinTotal, setNetWinTotal] = useState(0);
  const [wegaSportStakeTotal, setWegaSportStakeTotal] = useState(0);
  const [wegaSportWinningTotal, setWegaSportWinningTotal] = useState(0);
  const [wegaSportCommissionTotal, setWegaSportCommissionTotal] = useState(0);
  const [wegaSportNetWinTotal, setWegaSportNetWinTotal] = useState(0);
  const [gameStakeTotal, setGameStakeTotal] = useState(0);
  const [gameWinningTotal, setGameWinningTotal] = useState(0);
  const [gameCommissionTotal, setGameCommissionTotal] = useState(0);
  const [gameNetWinTotal, setGameNetWinTotal] = useState(0);

  // handle print
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });

  // Shared by both tabs. Each footer totals the page on screen, per tab - unchanged behaviour,
  // and the two tabs must not share one cumulative total.
  const sumTotals = (content) => {
    let stake = 0;
    let winning = 0;
    let commission = 0;
    let netWin = 0;

    if (content !== undefined && content !== null && content.length > 0) {
      content.forEach((data) => {
        if (data.amount !== undefined) stake += data.amount;

        if (data.winning !== undefined) winning += data.winning;

        if (data.commission !== undefined) commission += data.commission;

        if (data.commission !== undefined && data.winning !== undefined)
          netWin += data.commission + data.winning;
      });
    }
    return [stake, winning, commission, netWin];
  };

  const calculateTotal = (content) => {
    const [stake, winning, commission, netWin] = sumTotals(content);
    setStakeTotal(stake);
    setWinningTotal(winning);
    setCommissionTotal(commission);
    setNetWinTotal(netWin);
  };

  const calculateGameTotal = (content) => {
    const [stake, winning, commission, netWin] = sumTotals(content);
    setGameStakeTotal(stake);
    setGameWinningTotal(winning);
    setGameCommissionTotal(commission);
    setGameNetWinTotal(netWin);
  };

  const calculateWegaSportTotal = (content) => {
    const [stake, winning, commission, netWin] = sumTotals(content);
    setWegaSportStakeTotal(stake);
    setWegaSportWinningTotal(winning);
    setWegaSportCommissionTotal(commission);
    setWegaSportNetWinTotal(netWin);
  };

  // render the details
  useEffect(() => {
    axiosInstance
      .get(`portal/detail?date=${props.match.params.date}`)
      .then((res) => {
        //console.log(res.data.content);
        setDetail(res.data.content);
        setTotalPage(res.data.totalPages);
        setSportsCount(res.data.totalElements);
        calculateTotal(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data.status === 412) {
          history.push('/history');
        } else if (err.response && err.response.data.status === 401) {
          logout(history);
        }
      });

    // the two WeGa populations of the same day, read up front so every segment label can show its count
    axiosInstance
      .get(`portal/wega/detail?date=${props.match.params.date}&engine=SPORT`)
      .then((res) => {
        setWegaSportDetail(res.data.content);
        setWegaSportTotalPage(res.data.totalPages);
        setWegaSportCount(res.data.totalElements);
        calculateWegaSportTotal(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data.status === 401) {
          logout(history);
        }
      });

    axiosInstance
      .get(`portal/wega/detail?date=${props.match.params.date}&engine=WEGA`)
      .then((res) => {
        setGameDetail(res.data.content);
        setGameTotalPage(res.data.totalPages);
        setGameCount(res.data.totalElements);
        calculateGameTotal(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data.status === 401) {
          logout(history);
        }
      });
  }, [props.match.params.date, history]);

  // A player whose day is all WeGa has nothing in Sports, and Sports is the segment the page opens on - so
  // open the first segment that has rows, in the order the strip lists them. Only when Sports is empty: a
  // segment the player picked is never taken away from them.
  useEffect(() => {
    if (sportsCount > 0) return;
    if (wegaSportCount > 0) setTab(1);
    else if (gameCount > 0) setTab(2);
  }, [sportsCount, wegaSportCount, gameCount]);

  const handleChange = (event, value) => {
    //console.log(value);
    axiosInstance
      .get(`portal/detail?date=${props.match.params.date}`, {
        params: {
          pageNo: value - 1,
        },
      })
      .then((res) => {
        //console.log(res.data.content);
        setDetail(res.data.content);
        setTotalPage(res.data.totalPages);
        setSportsCount(res.data.totalElements);
        calculateTotal(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          logout(history);
        }
      });
  };

  const handleWegaSportChange = (event, value) => {
    axiosInstance
      .get(`portal/wega/detail?date=${props.match.params.date}&engine=SPORT`, {
        params: {
          pageNo: value - 1,
        },
      })
      .then((res) => {
        setWegaSportDetail(res.data.content);
        setWegaSportTotalPage(res.data.totalPages);
        setWegaSportCount(res.data.totalElements);
        calculateWegaSportTotal(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          logout(history);
        }
      });
  };

  const handleGameChange = (event, value) => {
    axiosInstance
      .get(`portal/wega/detail?date=${props.match.params.date}&engine=WEGA`, {
        params: {
          pageNo: value - 1,
        },
      })
      .then((res) => {
        setGameDetail(res.data.content);
        setGameTotalPage(res.data.totalPages);
        setGameCount(res.data.totalElements);
        calculateGameTotal(res.data.content);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.status === 401) {
          logout(history);
        }
      });
  };

  // modal handling
  const handleView = (betId) => {
    // const betId = e.target.id;
    axiosInstance
      .get(`portal/mix?id=${betId}`)
      .then((res) => {
        setData(res.data);
        //console.log(res.data);
        setOpen(true);
      })
      .catch((err) => {
        console.log(err);
        if (err.response && err.response.data.status === 401) {
          logout(history);
        }
      });
  };
  const handleClose = () => {
    setOpen(false);
  };
  // The vendor's page is the only place a WeGa bet's legs, odds, handicap, score and combo structure are
  // written down - neither our rows nor the vendor's callbacks carry them - so every games row offers it, a
  // settled, open or cancelled bet alike (the vendor shows a cancelled bet as cancelled rather than refusing).
  const handleTradeDetail = (pubId) => {
    setTradeDetail({ open: true, loading: true, url: null });
    fetchSabaTradeDetail(pubId)
      .then((url) => {
        setTradeDetail({ open: true, loading: false, url });
      })
      .catch((err) => {
        setTradeDetail({ open: true, loading: false, url: null });
        if (err.response && err.response.status === 401) {
          logout(history);
        }
      });
  };
  const handleTradeDetailClose = () => {
    // closing drops the ticket: reopening asks for a fresh one
    setTradeDetail({ open: false, loading: false, url: null });
  };
  // The two WeGa populations share one table: a WeGa sports row carries exactly the fields a games row does
  // (no teams, odds, handicap or score), so the same nine columns serve both, and only the read behind them
  // and the footer totals differ. Which one is on screen is the segment.
  const wegaRows = tab === 1 ? wegaSportDetail : gameDetail;
  const wegaTotalPage = tab === 1 ? wegaSportTotalPage : gameTotalPage;
  const wegaStakeTotal = tab === 1 ? wegaSportStakeTotal : gameStakeTotal;
  const wegaWinningTotal = tab === 1 ? wegaSportWinningTotal : gameWinningTotal;
  const wegaCommissionTotal = tab === 1 ? wegaSportCommissionTotal : gameCommissionTotal;
  const wegaNetWinTotal = tab === 1 ? wegaSportNetWinTotal : gameNetWinTotal;

  return (
    <>
      <Navbar User={props.User.user} />
      <div className={classes.MainArea}>
        <TickerNews />
      </div>
      <div className={classes.MainArea2}>
        <Grid container spacing={2}>
          <Grid item className={classes.LeftPanel}>
            <LeftSide User={props.User} quote={quote} setQuote={setQuote} />
          </Grid>
          <Grid item className={classes.RightPanel}>
            <div className="HistoryDetail">
              <div className={classes.flex}>
                <div className={classes.flex2}>
                  <img
                    src={require('../img/Icons/time-17.svg')}
                    alt=""
                    className={classes.img}
                  />
                  <p className={classes.header}>
                    <span
                      className={`lang-${localStorage.getItem('language')}`}
                    >
                      {t('History Details')}
                    </span>
                  </p>
                  <Link to="#" className={classes.print} onClick={handlePrint}>
                    <span
                      className={`lang-${localStorage.getItem('language')}`}
                    >
                      {t('Print')}
                    </span>
                  </Link>
                </div>
                <div>
                  <Link
                    to="/history"
                    style={{ color: '#18334C', margin: '0 1rem' }}
                  >
                    <span
                      className={`lang-${localStorage.getItem('language')}`}
                    >
                      {t('Back To History')}
                    </span>
                  </Link>
                </div>
              </div>

              {/* One segment per population, and only the ones with rows: a segment reading "(0)" opens an
                  empty list, and the effect above already opens the first segment that has rows, so hiding
                  one cannot leave a blank list on screen. When no segment has rows there is nothing to
                  switch between, so the strip goes and the list below keeps its own "No bet history". */}
              {sportsCount > 0 || wegaSportCount > 0 || gameCount > 0 ? (
                <div className="segment-toggle">
                  {sportsCount > 0 ? (
                    <button
                      type="button"
                      className={`${tab === 0 ? 'active' : ''} lang-${localStorage.getItem('language')}`}
                      onClick={() => setTab(0)}
                    >
                      {t('Sports')} ({sportsCount})
                    </button>
                  ) : null}
                  {wegaSportCount > 0 ? (
                    <button
                      type="button"
                      className={`${tab === 1 ? 'active' : ''} lang-${localStorage.getItem('language')}`}
                      onClick={() => setTab(1)}
                    >
                      {t('WeGa sport')} ({wegaSportCount})
                    </button>
                  ) : null}
                  {gameCount > 0 ? (
                    <button
                      type="button"
                      className={`${tab === 2 ? 'active' : ''} lang-${localStorage.getItem('language')}`}
                      onClick={() => setTab(2)}
                    >
                      {t('Games')} ({gameCount})
                    </button>
                  ) : null}
                </div>
              ) : null}

              {tab === 0 && detail !== null ? (
                <>
                  <table ref={printRef} style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th style={{ borderRadius: '4px 0 0 0' }}>
                          <span
                            className={`lang-${localStorage.getItem(
                              'language'
                            )}`}
                          >
                            {t('No.')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem(
                              'language'
                            )}`}
                          >
                            {t('Date & Time')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem(
                              'language'
                            )}`}
                          >
                            {t('Bet Type')}
                          </span>
                        </th>

                        <th>
                          <span
                            className={`lang-${localStorage.getItem(
                              'language'
                            )}`}
                          >
                            {t('Details')}
                          </span>
                        </th>
                        <th style={{ padding: '0' }}>
                          <span
                            className={`lang-${localStorage.getItem(
                              'language'
                            )}`}
                          >
                            {t('FT/HT')}
                          </span>
                        </th>
                        {/* <th style={{ padding: "0" }}></th> */}
                        <th>
                          <span
                            className={`lang-${localStorage.getItem(
                              'language'
                            )}`}
                          >
                            {t('Stake')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem(
                              'language'
                            )}`}
                          >
                            {t('Winning')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem(
                              'language'
                            )}`}
                          >
                            {t('Commission')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem(
                              'language'
                            )}`}
                          >
                            {t('Net Win')}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {detail.map((info, index) => (
                        <tr key={index}>
                          <td>
                            <p className={classes.index}>{index + 1}</p>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <p style={{ margin: '0.15rem 0' }}>
                              {moment(info.created).format('DD/MM/YY')}
                            </p>
                            <p>{moment(info.created).format('hh:mm a')}</p>
                          </td>
                          <td>
                            {info.market === 'PARLAY' ? (
                              <div className={classes.spacing}>
                                <p className={classes.teams}>{info.type}</p>
                                <p className={classes.teams}>
                                  {info.reference}
                                </p>
                              </div>
                            ) : (
                              <div className={classes.spacing}>
                                <p className={classes.teams}>
                                  {info.sport} {info.market}
                                </p>
                                <p className={classes.teams}>{info.game}</p>
                                <p className={classes.teams}>
                                  {info.reference}
                                </p>
                              </div>
                            )}
                          </td>

                          <td>
                            {info.market === 'PARLAY' ? (
                              <div
                                className={classes.flex}
                                style={{
                                  justifyContent: 'space-between',
                                  padding: '0 0.5rem',
                                }}
                              >
                                <p className={classes.compName}>
                                  <span
                                    className={`lang-${localStorage.getItem(
                                      'language'
                                    )}`}
                                  >
                                    {t('Mix Parlay_')}
                                  </span>{' '}
                                  <CurrencyFormat
                                    value={info.odds}
                                    decimalScale={2}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    fixedDecimalScale={true}
                                  />
                                </p>
                                <button
                                  className={classes.view}
                                  onClick={() => {
                                    handleView(info.bet);
                                  }}
                                >
                                  <span
                                    className={`lang-${localStorage.getItem(
                                      'language'
                                    )}`}
                                  >
                                    {t('View Detail')}
                                  </span>
                                </button>
                              </div>
                            ) : (
                              <div className={classes.spacing}>
                                <p
                                  className={`${classes.compName} ${
                                    info.status === 'REJECTED' ||
                                    info.status === 'CANCELLED'
                                      ? classes.reject
                                      : null
                                  }`}
                                >
                                  {info.comp} {info.compType}
                                </p>
                                <p
                                  className={`${classes.teams} ${
                                    info.status === 'REJECTED' ||
                                    info.status === 'CANCELLED'
                                      ? classes.reject
                                      : null
                                  }`}
                                >
                                  <span
                                    className={
                                      info.high === 1 ? classes.strong : null
                                    }
                                  >
                                    {info.home} vs{' '}
                                  </span>
                                  <span
                                    className={
                                      info.high === 2 ? classes.strong : null
                                    }
                                  >
                                    {info.away}
                                  </span>
                                </p>
                                {info.market === 'LIVE' ? (
                                  <p className={classes.running}>
                                    (Running {info.homeGoal}-{info.awayGoal})
                                  </p>
                                ) : null}
                                <p
                                  className={`${classes.handiCap} ${
                                    info.status === 'REJECTED' ||
                                    info.status === 'CANCELLED'
                                      ? classes.reject
                                      : ''
                                  }`}
                                >
                                  <span className={classes.compName}>
                                    {info.desc}{' '}
                                    {info.handicap !== '' ? (
                                      <span className={classes.handiCap}>
                                        ({info.handicap}){' '}
                                      </span>
                                    ) : null}
                                    <span>
                                      @{' '}
                                      <CurrencyFormat
                                        value={info.odds}
                                        decimalScale={2}
                                        displayType={'text'}
                                        thousandSeparator={true}
                                        fixedDecimalScale={true}
                                      />
                                    </span>
                                  </span>
                                </p>
                                {info.status === 'REJECTED' ||
                                info.status === 'CANCELLED' ? (
                                  // <div className={classes.flex}>
                                  <p className={classes.running}>
                                    <span
                                      className={`lang-${localStorage.getItem(
                                        'language'
                                      )}`}
                                    >
                                      {t('Reject')}
                                    </span>{' '}
                                    {info.rejectReason
                                      ? '(' + info.rejectReason + ')'
                                      : ''}
                                  </p>
                                ) : // </div>
                                null}
                              </div>
                            )}
                          </td>
                          <td style={{ padding: '0', minWidth: '30px' }}>
                            <p className={classes.score}>
                              {info.ftHome}-{info.ftAway}
                              <br />({info.fhHome}-{info.fhAway})
                            </p>
                          </td>
                          {/* <td style={{ padding: "0", minWidth: "30px" }}>
                            <p className={classes.score}>
                              {info.ftHome}-{info.ftAway}
                            </p>
                          </td> */}
                          <td>
                            <p
                              className={`${classes.money} ${
                                info.amount < 0 ? classes.negative : null
                              }`}
                            >
                              <CurrencyFormat
                                value={info.amount}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </p>
                          </td>
                          <td>
                            <p
                              className={`${classes.money} ${
                                info.winning < 0 ? classes.negative : null
                              }`}
                            >
                              <CurrencyFormat
                                value={info.winning}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </p>
                          </td>
                          <td>
                            <p
                              className={`${classes.money} ${
                                info.commission < 0 ? classes.negative : null
                              }`}
                            >
                              <CurrencyFormat
                                value={info.commission}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </p>
                          </td>
                          <td>
                            <p
                              className={`${classes.money} ${
                                info.winning + info.commission < 0
                                  ? classes.negative
                                  : null
                              }`}
                            >
                              <CurrencyFormat
                                value={info.winning + info.commission}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </p>
                          </td>
                        </tr>
                      ))}
                      {detail.length === 0 ? (
                        <tr>
                          <td colSpan={9} style={{ textAlign: 'center' }}>
                            <p className={classes.teams}>
                              <span
                                className={`lang-${localStorage.getItem(
                                  'language'
                                )}`}
                              >
                                {t('No bet history')}
                              </span>
                            </p>
                          </td>
                        </tr>
                      ) : null}
                      {detail.length > 0 ? (
                      <tr key={'total'} style={{ borderTop: '2px solid #86898c' }}>
                        <td colSpan={5}>
                          <center className={classes.font14}>
                            <b>
                              <span
                                className={`lang-${localStorage.getItem(
                                  'language'
                                )}`}
                              >
                                {t('Total')}
                              </span>
                            </b>
                          </center>
                        </td>
                        <td>
                          <p
                            className={`${classes.money} ${
                              stakeTotal < 0 ? classes.negative : null
                            } ${classes.font14}`}
                          >
                            <CurrencyFormat
                              value={stakeTotal}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </p>
                        </td>
                        <td>
                          <p
                            className={`${classes.money} ${
                              winningTotal < 0 ? classes.negative : null
                            } ${classes.font14}`}
                          >
                            <CurrencyFormat
                              value={winningTotal}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </p>
                        </td>
                        <td>
                          <p
                            className={`${classes.money} ${
                              commissionTotal < 0 ? classes.negative : null
                            } ${classes.font14}`}
                          >
                            <CurrencyFormat
                              value={commissionTotal}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </p>
                        </td>
                        <td>
                          <p
                            className={`${classes.money} ${
                              netWinTotal < 0 ? classes.negative : null
                            } ${classes.font14}`}
                          >
                            <CurrencyFormat
                              value={netWinTotal}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </p>
                        </td>
                      </tr>
                      ) : null}
                    </tbody>
                  </table>
                  <Pagination
                    count={totalPage}
                    onChange={handleChange}
                    className={classes.pagination}
                  />
                </>
              ) : null}

              {/* WeGa segment: the same day's WeGa bets of one population. Different columns on purpose - a
                  WeGa bet has no teams, odds, handicap or score, so those fields do not exist here rather
                  than showing blank. Cancelled bets stay listed at zero, as on the history page, and are
                  struck through. */}
              {(tab === 1 || tab === 2) && wegaRows !== null ? (
                <>
                  <table ref={printRef} style={{ width: '100%' }}>
                    <thead>
                      <tr>
                        <th style={{ borderRadius: '4px 0 0 0' }}>
                          <span
                            className={`lang-${localStorage.getItem('language')}`}
                          >
                            {t('No.')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem('language')}`}
                          >
                            {t('Date & Time')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem('language')}`}
                          >
                            {t('Game')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem('language')}`}
                          >
                            {t('Category')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem('language')}`}
                          >
                            {t('Reference')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem('language')}`}
                          >
                            {t('Stake')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem('language')}`}
                          >
                            {t('Winning')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem('language')}`}
                          >
                            {t('Commission')}
                          </span>
                        </th>
                        <th>
                          <span
                            className={`lang-${localStorage.getItem('language')}`}
                          >
                            {t('Net Win')}
                          </span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {wegaRows.map((info, index) => (
                        <tr key={index}>
                          <td>
                            <p className={classes.index}>{index + 1}</p>
                          </td>
                          <td style={{ textAlign: 'center' }}>
                            <p style={{ margin: '0.15rem 0' }}>
                              {moment(info.created).format('DD/MM/YY')}
                            </p>
                            <p>{moment(info.created).format('hh:mm a')}</p>
                          </td>
                          <td>
                            <div className={classes.spacing}>
                              <p
                                className={`${classes.teams} ${
                                  info.status === 'CANCELLED'
                                    ? classes.reject
                                    : null
                                }`}
                              >
                                {info.game}
                              </p>
                              {info.status === 'CANCELLED' ? (
                                <p className={classes.running}>
                                  <span
                                    className={`lang-${localStorage.getItem(
                                      'language'
                                    )}`}
                                  >
                                    {t('Reject')}
                                  </span>
                                </p>
                              ) : null}
                            </div>
                          </td>
                          <td>
                            <p
                              className={`${classes.teams} ${
                                info.status === 'CANCELLED'
                                  ? classes.reject
                                  : null
                              }`}
                            >
                              {info.category || info.categoryCode}
                            </p>
                          </td>
                          <td>
                            {/* the reference is the bet, so it is the way in - the same shape as the date on
                                /history: a link in the row's own colour, no button and no extra label. A
                                cancelled bet keeps its reference clickable; the vendor shows it as cancelled
                                rather than refusing. */}
                            <p
                              className={`${classes.teams} ${
                                info.status === 'CANCELLED'
                                  ? classes.reject
                                  : null
                              }`}
                            >
                              <Link
                                to="#"
                                style={{ color: '#323030' }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleTradeDetail(info.pubId);
                                }}
                              >
                                {info.reference}
                              </Link>
                            </p>
                          </td>
                          <td>
                            <p
                              className={`${classes.money} ${
                                info.amount < 0 ? classes.negative : null
                              }`}
                            >
                              <CurrencyFormat
                                value={info.amount}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </p>
                          </td>
                          <td>
                            <p
                              className={`${classes.money} ${
                                info.winning < 0 ? classes.negative : null
                              }`}
                            >
                              <CurrencyFormat
                                value={info.winning}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </p>
                          </td>
                          <td>
                            <p
                              className={`${classes.money} ${
                                info.commission < 0 ? classes.negative : null
                              }`}
                            >
                              <CurrencyFormat
                                value={info.commission}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </p>
                          </td>
                          <td>
                            <p
                              className={`${classes.money} ${
                                info.winning + info.commission < 0
                                  ? classes.negative
                                  : null
                              }`}
                            >
                              <CurrencyFormat
                                value={info.winning + info.commission}
                                decimalScale={2}
                                displayType={'text'}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                              />
                            </p>
                          </td>
                        </tr>
                      ))}
                      {wegaRows.length === 0 ? (
                        <tr>
                          <td colSpan={9} style={{ textAlign: 'center' }}>
                            <p className={classes.teams}>
                              <span
                                className={`lang-${localStorage.getItem(
                                  'language'
                                )}`}
                              >
                                {t('No bet history')}
                              </span>
                            </p>
                          </td>
                        </tr>
                      ) : null}
                      {wegaRows.length > 0 ? (
                      <tr key={'game-total'} style={{ borderTop: '2px solid #86898c' }}>
                        <td colSpan={5}>
                          <center className={classes.font14}>
                            <b>
                              <span
                                className={`lang-${localStorage.getItem(
                                  'language'
                                )}`}
                              >
                                {t('Total')}
                              </span>
                            </b>
                          </center>
                        </td>
                        <td>
                          <p
                            className={`${classes.money} ${
                              wegaStakeTotal < 0 ? classes.negative : null
                            } ${classes.font14}`}
                          >
                            <CurrencyFormat
                              value={wegaStakeTotal}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </p>
                        </td>
                        <td>
                          <p
                            className={`${classes.money} ${
                              wegaWinningTotal < 0 ? classes.negative : null
                            } ${classes.font14}`}
                          >
                            <CurrencyFormat
                              value={wegaWinningTotal}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </p>
                        </td>
                        <td>
                          <p
                            className={`${classes.money} ${
                              wegaCommissionTotal < 0 ? classes.negative : null
                            } ${classes.font14}`}
                          >
                            <CurrencyFormat
                              value={wegaCommissionTotal}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </p>
                        </td>
                        <td>
                          <p
                            className={`${classes.money} ${
                              wegaNetWinTotal < 0 ? classes.negative : null
                            } ${classes.font14}`}
                          >
                            <CurrencyFormat
                              value={wegaNetWinTotal}
                              decimalScale={2}
                              displayType={'text'}
                              thousandSeparator={true}
                              fixedDecimalScale={true}
                            />
                          </p>
                        </td>
                      </tr>
                      ) : null}
                    </tbody>
                  </table>
                  <Pagination
                    count={wegaTotalPage}
                    onChange={tab === 1 ? handleWegaSportChange : handleGameChange}
                    className={classes.pagination}
                  />
                </>
              ) : null}
            </div>
          </Grid>
        </Grid>

        {/* modal  */}
        <ViewDetailModal data={data} open={open} handleClose={handleClose} />
        <TradeDetailModal
          open={tradeDetail.open}
          handleClose={handleTradeDetailClose}
          url={tradeDetail.url}
          loading={tradeDetail.loading}
        />
      </div>
    </>
  );
};

export default HistoryDetail;
